module.exports = __webpack_public_path__ + "img/IMG_0204-15_L.7dd71864.webp";